import { Stack } from '@mui/material';

import { FormAutocompleteField, FormTextField } from '../../../../../common';
import { ASSESSMENT_DSM5_SYMPTOM_OPTIONS } from '../constants';

import type { MaladaptiveBehaviorFieldsProps } from './types';

export default function MaladaptiveBehaviorFields({
  formik,
  disabled,
  readOnly,
  saveField,
}: MaladaptiveBehaviorFieldsProps) {
  return (
    <Stack gap={2}>
      <FormTextField
        disabled={disabled}
        formik={formik}
        label="Maladaptive behavior"
        name="behavior"
        onBlur={saveField}
        placeholder="Enter maladaptive behavior"
        readOnly={readOnly}
        required
      />
      <FormAutocompleteField
        disabled={disabled}
        formik={formik}
        label="Respective DSM5 symptoms"
        name="dsm5_symptom"
        onChange={saveField}
        options={ASSESSMENT_DSM5_SYMPTOM_OPTIONS.map((symptom) => ({
          value: symptom,
          label: symptom,
        }))}
        placeholder="Select DSM5"
        readOnly={readOnly}
        required
      />
      <FormTextField
        disabled={disabled}
        formik={formik}
        label="Maladaptive concerns as reported by parents"
        name="parent_concerns"
        onBlur={saveField}
        placeholder="Describe parents concerns"
        readOnly={readOnly}
        required
      />
    </Stack>
  );
}
